//import React from 'react';
//import { connect } from 'react-redux';
//
//const Home = props => (
//  <div>
//    <h4>Welcome!</h4>
//  </div>
//);
//
//export default connect()(Home);

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actionCreators } from '../store/LoginActionsReducers';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';

import api from '../ApiService';

export class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            greeting: ''
        };
    }

    componentDidMount = async () => {
        // Whenever we come to the home page, check if the token is still good
        const isTokenValid = await api.isTokenValid();

        if (isTokenValid) {
            let user = JSON.parse(localStorage.getItem('user'));
            let greeting = `Welcome ${user.email}!`;
            this.setState({ greeting });
        }
        else {
            this.setState({ greeting: '' });
            this.props.signOut();
        }
    }

    render() {
        if (!this.props.isAuthenticated) {
            return (
                <Redirect to="/login" />
            );
        }

        // Preserve OAuth callback parameters when redirecting to /hospitals
        const searchParams = window.location.search;
        const redirectPath = searchParams ? `/hospitals${searchParams}` : '/hospitals';

        return (
            //<div>
            //    <h3>{this.state.greeting}</h3>
            //    <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
            //        <img src='/home.jpg' style={{ width: '100%', height: '100%' }} alt="" />
            //    </div>
            //</div>
            <Redirect to={redirectPath} />
        );

    }
}

export default withRouter(connect(state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Home));



// WEBPACK FOOTER //
// ./src/components/Home.js